import { gql } from '__generated__';

export default gql(`
  mutation RestoreOrder($id: ID!) {
    restoreOrder(id: $id) {
      id
    }
  }
`);
